import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { useBilledSimState } from 'console/sim/utils/status';
import { WithOutChangeTariff } from './without-change-tariff';
import { WithChangeTariff } from './with-change-tariff';
export function BilledSimPayFormRouter() {
    const { sim_id, operator } = useParams();
    return _jsx(BilledSimPayForm, { sim_id: sim_id, operator: operator });
}
export const BilledSimPayForm = memo(function BilledSimPayForm(props) {
    const { sim_id, operator } = props;
    const [billed_sim, sim_state] = useBilledSimState(sim_id, operator);
    if (billed_sim == null || sim_state == null) {
        return null;
    }
    return (_jsx(Box, { p: 2, display: "flex", flexDirection: "column", gap: 2, children: billed_sim.terminated ? (_jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u044B \u043F\u0440\u0435\u043A\u0440\u0430\u0449\u0435\u043D\u043E" }), "\u041C\u043E\u0436\u043D\u043E \u0437\u0430\u043A\u0430\u0437\u0430\u0442\u044C ", _jsx(Link, { to: "/sim/order", children: "\u043D\u043E\u0432\u0443\u044E \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u0443" })] })) : billed_sim.tariff_state.next != null ? (_jsx(WithChangeTariff, { billed_sim: billed_sim, sim_state: sim_state })) : (_jsx(WithOutChangeTariff, { billed_sim: billed_sim, sim_state: sim_state })) }));
});
